exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ag-header-cell-label{justify-content:center!important}.slide-enter{transform:translateX(30vw)}.slide-enter-active,.slide-leave-active{transition:all .3s ease-in}.slide-leave-to,.slide-two-enter{transform:translateX(30vw)}.slide-two-enter-active,.slide-two-leave-active{transition:all .3s ease-in}.slide-two-leave-to{transform:translateX(30vw)}.tag-process{font-size:11px!important;margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52101ca6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lideres/Proceso.vue
// module id = 828
// module chunks = 2